export default "__VITE_ASSET__l9nBZ3tn__"